import { BRANDS, applyBrand, resolveBrand, type Brand } from "../theme/brand";
import { useState } from "react";

/**
 * Switches palette at runtime.
 *
 * Present because the brand is a known open question: the prototype uses Shell's palette and
 * the product needs its own. Being able to show either in the same session, without a rebuild,
 * is what turns that into a decision someone can actually make.
 */
export function BrandSwitcher() {
  const [brand, setBrand] = useState<Brand>(resolveBrand());
  return (
    <select
      aria-label="Brand"
      value={brand}
      onChange={(e) => {
        const next = e.target.value as Brand;
        setBrand(next);
        applyBrand(next);
      }}
    >
      {BRANDS.map((b) => (
        <option key={b} value={b}>
          {b}
        </option>
      ))}
    </select>
  );
}
